<template>
<div class="slide slide06">
	<h3 class="title">
		자체 개발 서비스 중인 미디어 플랫폼 서비스를 통해 <br> 광고주의 퍼포먼스 효율 향상에 기여합니다
	</h3>
	<span class="text">
		독자 개발한 디지털 비디오 광고, 앱 퍼포먼스 광고, 인플루언서 광고 플랫폼 보유하고 있어 <br>
		웹, 모바일, SNS를 융합하는 통합 디지털 미디어 서비스를 제공하여 퍼포먼스 효과를 향상시키는데 기여합니다.
	</span>

	<div class="tableBox" v-if="$device.windows">
		<table class="table">
			<colgroup>
				<col width="33.3333%">
				<col width="33.3333%">
				<col width="33.3333%">
			</colgroup>
			<thead>
				<th>
					<span>Viscuit</span>
					<span class="color04">Video Advertising Platform</span>
				</th>
				<th>
					<span>PicknShare</span>
					<span class="color04">App Performance Advertising Platform</span>
				</th>
				<th>
					<span>LikenClick</span>
					<span class="color04">Influencer Advertising Platform</span>
				</th>
			</thead>
			<tbody>
				<tr class="first">
					<td>
						<ul class="list">
							<li>
								비디오 컨텐츠 시청자 또는 <br> 모바일 앱 사용자를 대상으로 <br> 비디오 광고를 노출시키는 광고 플랫폼
							</li>
							<li>
								제휴 매체 수 1000개 이상
							</li>
						</ul>
					</td>
					<td>
						<ul class="list">
							<li>
								nCPI 광고, 사전예약, CPA광고에 <br> 특화된 앱 퍼포먼스 광고 플랫폼
							</li>
							<li>
								캠페인 개별 소재 링크를 발행하여 <br> 소재 별 성과 분석 가능
							</li>
						</ul>
					</td>
					<td>
						<ul class="list">
							<li>
								FB의 인플루언서와 <br> 파워페이지를 토대로 컨텐츠를 <br> 페이스북 게시물 형태로 <br> 게재하는 광고 플랫폼
							</li>
							<li>
								200개 이상의 제휴
							</li>
							<li>
								페이스북 페이지 보유
							</li>
						</ul>
					</td>
				</tr>
				<tr class="two">
					<td>
						<img src="@/assets/images/btnArrowDownB.png" alt=""> 동영상 확산에 기여
					</td>
					<td>
						<img src="@/assets/images/btnArrowDownB.png" alt=""> 앱 설치 증대, 앱 사용자 <br> 확보에 기여
					</td>
					<td>
						<img src="@/assets/images/btnArrowDownB.png" alt=""> SNS를 통한 <br> 컨텐츠 확산에 기여
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div class="serviceImg" v-else>
		<img src="@/assets/images/featureSlideMo05.png" alt="">
	</div>
	<div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">처음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
	methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>